/* eslint-disable react/prop-types */
import { ShoppingCart as ShoppingCartIcon } from '@mui/icons-material';
import { Badge, Box, IconButton } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { USER_TYPE } from '../../../utils/constants';

const UserCartButton = ({ data, modalComponent, cartColor, userId, type, fetchAction }) => {
  const [isCartDialogOpen, setIsCartDialogOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.currentUser);

  const { orders = {}, quotes = {} } = useSelector((state) => state.users);

  const cartData = type === 'orders' ? orders.data || [] : quotes.data || [];

  const onCartClick = (e) => {
    e.preventDefault();
  };

  return (
    <Box sx={{}}>
      {data && (
        <IconButton
          size="large"
          aria-label="cart"
          color={cartColor}
          onClick={() => {
            setIsModalOpen(true);
            setIsCartDialogOpen(true);
            if (user.type === USER_TYPE.SELLER_MARKETPLACE_ADMIN) {
              dispatch(fetchAction(userId, user.companyId));
            } else {
              dispatch(fetchAction(userId));
            }
          }}
        >
          <Badge
            badgeContent={data}
            color="error"
            style={{
              marginTop: '10px',
              backgroundColor: 'white',
              borderRadius: '25px',
              padding: '5px',
            }}
          >
            <ShoppingCartIcon />
          </Badge>
        </IconButton>
      )}
  {modalComponent && isModalOpen && cartData.length > 0 && (
        <modalComponent.type
          isOpen={isCartDialogOpen}
          data={cartData}
          onCloseClick={() => {
            setIsCartDialogOpen(false);
          }}
          onActionClick={onCartClick}
          onModalCloseClick={() => {
            setIsModalOpen(false);
          }}
          {...modalComponent.props}
        />
  )}
    </Box>
  );
};

export default UserCartButton;
